import React, { useState, useEffect, useContext } from 'react';
import PieChart from '../charts/PieChart';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';
import ClipLoader from 'react-spinners/ClipLoader';
import CONFIG from '../config.js';

const PieChartSection = ({ weekData, weekdayData, weekendData }) => {
    const { user, fetchData, setFetchData, isAdmin, adminSelectedUser } = useContext(AuthContext);
    let userInfo = user;
    if (isAdmin) {
        userInfo = adminSelectedUser;
    }
    const [selected, setSelected] = useState('weekly');
    const pie_chart_labels = ['> Top 25 Percentile', '< Top 25 Percentile'];
    const [loading, setLoading] = useState(false);
    const [pieChartInsights, setPieChartInsights] = useState();
    const [currentIndex, setCurrentIndex] = useState(0);
    const url = CONFIG.createUrl();

    const config = {headers: CONFIG.HEADERS};

    const handleSelect = (button) => {
        setCurrentIndex(0);
        setSelected(button);
    };

    const fetchInsights = async () => {
        try {
            const [weeklyResponse, monthlyResponse, quarterlyResponse] = await axios.all([
                axios.get(`${url}weekday-weekend-insights?uuid=${userInfo.uuid}&start_date=${fetchData.weekStartDate}&end_date=${fetchData.maxDate}`, config),
                axios.get(`${url}weekday-weekend-insights?uuid=${userInfo.uuid}&start_date=${fetchData.monthStartDate}&end_date=${fetchData.maxDate}`, config),
                axios.get(`${url}weekday-weekend-insights?uuid=${userInfo.uuid}&start_date=${fetchData.quarterStartDate}&end_date=${fetchData.maxDate}`, config),
            ]);
            const newInsights = {
                weekly: weeklyResponse.data.recommendations,
                monthly: monthlyResponse.data.recommendations,
                quarterly: quarterlyResponse.data.recommendations
            }
            setPieChartInsights(newInsights);
            setFetchData(prev => ({ ...prev, pieChartInsightsData: newInsights }))
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    // useEffect(() => {
    //     if (!fetchData.pieChartInsightsData) {
    //         fetchInsights();
    //     } else {
    //         setPieChartInsights(fetchData.pieChartInsightsData);
    //         setLoading(false);
    //     }
    // }, []);

    const goToPrevious = (slides) => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? slides.length - 1 : prevIndex - 1));
    };

    const goToNext = (slides) => {
        setCurrentIndex((prevIndex) => (prevIndex === slides.length - 1 ? 0 : prevIndex + 1));
    };
    const renderPieChartInsights = () => {
        const insightHeaders = Object.keys(pieChartInsights[selected]);
        return (
            <div style={{ position: "relative", height: "250px" }}>
                {insightHeaders.map((slide, index, arr) => (
                    <div
                        key={`pieChart-slide-${index}`}
                        className="carousel-slide"
                        style={{
                            opacity: index === currentIndex ? 1 : 0,
                            transition: 'opacity 0.5s ease-in-out',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            visibility: index === currentIndex ? 'visible' : 'hidden', // Ensure hidden slides don't capture events
                        }}
                    >
                        <div>
                            {/* <div className="carousel-page-container"> */}
                            <p className="pieChart-insights-header"><b>{slide}</b></p>
                            {/* <div>{index + 1} of {arr.length}</div>
                            </div> */}
                            <ul>
                                {pieChartInsights[selected][slide].map((summaryItem, ind) => (
                                    <li key={`pieChart-insights-item-${ind}`}>{summaryItem}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}

                <button className="carousel-button prev" onClick={() => goToPrevious(insightHeaders)}>
                    <i className="fa-solid fa-chevron-left"></i>
                </button>
                <button className="carousel-button next" onClick={() => goToNext(insightHeaders)}>
                    <i className="fa-solid fa-chevron-right"></i>
                </button>
            </div>
        );
    }

    return (
        <div className="pie-chart-section">
            <h4 className="page-title section-header">Proportion of Days Spent in Top 25 Percentile HRV</h4>
            <div className="toggle-button-container">
                <button
                    onClick={() => handleSelect('weekly')}
                    className="toggle-button"
                    style={{
                        backgroundColor: selected === 'weekly' ? 'rgb(124 202 204)' : '#f0f0f0',
                        color: selected === 'weekly' ? '#fff' : '#000',
                    }}
                >
                    Weekly
                </button>

                <button
                    onClick={() => handleSelect('monthly')}
                    className="toggle-button"
                    style={{
                        background: selected === 'monthly' ? 'rgb(124 202 204)' : '#f0f0f0',
                        color: selected === 'monthly' ? '#fff' : '#000',
                    }}
                >
                    Monthly
                </button>

                <button
                    onClick={() => handleSelect('quarterly')}
                    className="toggle-button"
                    style={{
                        background: selected === 'quarterly' ? 'rgb(124 202 204)' : '#f0f0f0',
                        color: selected === 'quarterly' ? '#fff' : '#000',
                    }}
                >
                    Quarterly
                </button>
            </div>
            <div className="pie-chart-container">
                <PieChart selected={selected} labels={pie_chart_labels} data={weekData[selected].data} weekdayText={weekdayData[selected].text} weekendText={weekendData[selected].text} title="Week" />
                <PieChart selected={selected} labels={pie_chart_labels} data={weekdayData[selected].data} weekdayText={weekdayData[selected].text} weekendText={weekendData[selected].text} title="Weekdays" />
                <PieChart selected={selected} labels={pie_chart_labels} data={weekendData[selected].data} weekdayText={weekdayData[selected].text} weekendText={weekendData[selected].text} title="Weekends" />
            </div>


            {/* <div className="dashboard-carousel">
                <h4 className="recommendation-header">CONCIERGE INSIGHTS</h4>
                <div className="tab-content">
                    {loading &&
                        <div className="spinner-container">
                            <ClipLoader color={"#123abc"} loading={loading} size={50} />
                        </div>
                    }

                    {!loading &&
                        <>{renderPieChartInsights()}</>
                    }
                </div>
            </div> */}
        </div>
    );
}

export default PieChartSection;